import { toast } from 'react-toastify';
import { useTranslations } from 'next-intl';
import { IGiftItemNotifications } from '@monofront/types';

export const useGiftItemNotifications: () => IGiftItemNotifications = () => {
  const tGiftItemnotifications = useTranslations('GiftItem.notifications');

  const onRemoveGiftItem = (title: string) =>
    toast(tGiftItemnotifications.rich('onRemoveGiftItem', { title: title }), {
      toastId: 'remove-gift-item',
    });
  const onAddGiftItem = () => toast(tGiftItemnotifications('onAddGiftItem'));
  const onAddGiftItemError = () =>
    toast(tGiftItemnotifications('onAddGiftItemError'), {
      progressClassName: 'toast-error',
    });

  return {
    onRemoveGiftItem,
    onAddGiftItem,
    onAddGiftItemError,
  };
};
